import P from "../sounds/Pp.mp3";

const soundMap = {
  "0xE111": P,
};

export default soundMap;
